// src/components/Services.js
import React from "react";
import "./services.css";

export default function Services() {
  return (
    <div className="services-page">

      {/* ================= HEADER ================= */}
      <section className="services-hero">
        <h1>Our Services</h1>
        <p>
          We provide end-to-end renovation, electrical, and construction
          services tailored to residential and commercial needs.
        </p>
      </section>

      {/* ================= SERVICES GRID ================= */}
      <section className="services-grid-section">
        <div className="services-grid">

          <div className="service-card">
            <h3>Renovation Works</h3>
            <p>
              Complete residential and commercial renovation services,
              including design coordination and execution.
            </p>
          </div>

          <div className="service-card">
            <h3>Electrical Works</h3>
            <p>
              Certified electrical installation, rewiring, maintenance,
              and upgrading works.
            </p>
          </div>

          <div className="service-card">
            <h3>Partitioning Works</h3>
            <p>
              Professional partitioning solutions using drywall, glass,
              and custom materials.
            </p>
          </div>

          <div className="service-card">
            <h3>Painting Services</h3>
            <p>
              Interior and exterior painting with durable finishes and
              high-quality workmanship.
            </p>
          </div>

          <div className="service-card">
            <h3>Demolition Works</h3>
            <p>
              Safe and controlled demolition services following proper
              safety and regulatory standards.
            </p>
          </div>

          <div className="service-card">
            <h3>Hacking Works</h3>
            <p>
              Precise hacking works for walls, floors, and fittings with
              minimal disruption.
            </p>
          </div>

        </div>
      </section>

    </div>
  );
}
